import widgetConfig from './index';
import style from './../../component/common/style/index.scss';

let centerCls = {
    "justify-content": "center",
    "text-align": "center"
}
let GradeSummary = {

    tableIcons: {
        sortAscending: '<i className=""></i>', //ag-icon ag-icon-asc
        sortDescending: '<i className=""></i>',     //ag-icon ag-icon-desc          
    },
    chartConfig: {
        'type':"mscolumn2d",       
        "width": '96%',
        "height": '100%',
       
        "dataFormat": 'json',
        "dataSource": {
            "chart": {
                xaxisname: "Indicative grade",
                yaxisname: 'Number of <br /> students',
                rotateYAxisName: "0",
                formatnumberscale: "1",
                YAxisMinValue:'0',
                YAxisMaxValue:'3',
                numDivLines:'2',
               // plottooltext:"<b>$dataValue</b>",
                theme: "fusion",
               // drawcrossline: "1",
               // showPlotBorder: "1",
               // plotBorderThickness: "2",
                showValues: "1",
                showLegend:"0",
                showToolTip: "0"
            },
            categories:[],
            dataset: []
        }
    },
    legendsClass:[
        style.legendClass1,
        style.legendClass2,
        style.legendClass3,
        style.legendClass4,
        style.legendClass5,
        style.legendClass6,
        style.legendClass8,
        style.legendClass9,
        style.legendClass10,
        style.legendClass11,
        style.legendClass12
    ],
     groupCourse: [
        {
            groupeName:'7A maths',
            courseName:'KS3 maths', 
            courseId: '123',
            groupId: '321'
        },
            {
                groupeName:'7B maths',
                courseName: 'KS3 maths',
                courseId: '312',
                groupId: '213'
        }
    ]
   


}

export default GradeSummary;
